<script>
import { routeIsProfessional, routeStartsWith } from '@/helpers/routes'
import { mapGetters } from 'vuex'

export default {
  name: 'top-menu-professional',
  computed: {
    ...mapGetters(['userIsProfessional', 'userIsCompany']),
    routeIsProfessional () {
      return routeIsProfessional(this.$route)
    },
    routeIsRecord () {
      return routeStartsWith(this.$route, 'professional.record')
    },
    routeIsCompany () {
      return routeStartsWith(this.$route, 'professional.company')
    },
    routeIsAgenda () {
      return routeStartsWith(this.$route, 'professional.agenda')
    },
    routeIsSchedulings () {
      return routeStartsWith(this.$route, 'professional.schedulings')
    },
    routeIsCurriculum () {
      return routeStartsWith(this.$route, 'professional.curriculum')
    },
    routeIsDocuments () {
      return routeStartsWith(this.$route, 'professional.documents')
    },
    routeIsDocumentsCompany () {
      return routeStartsWith(this.$route, 'professional.company.documents')
    }
  }
}
</script>

<template lang="pug">
    ul.hidden-sm.hidden-md.hidden-xs
      li(:class="{'active': routeIsRecord }", v-if="userIsProfessional")
          router-link(:to="{name: 'professional.record.registration.me'}")
            | Perfil Profissional

      li(:class="{'active': routeIsCompany  && !routeIsDocumentsCompany}")
          router-link(:to="{name: 'professional.company.companies.edit'}")
            | Dados Cadastrais

      li(:class="{'active': routeIsAgenda}")
          router-link(:to="{name: 'professional.agenda.agendas.index'}")
            | Agenda Profissional

      li(:class="{'active': routeIsSchedulings}")
          router-link(:to="{name: 'professional.schedulings.index'}")
            | Agendamentos

      li(:class="{'active': routeIsCurriculum}", v-if="userIsProfessional")
          router-link(:to="{name: 'professional.curriculum.graduations.index'}")
            | Curriculum

      li(:class="{'active': routeIsDocuments}", v-if="userIsProfessional")
          router-link(:to="{name: 'professional.documents.index'}")
            | Documentos

      li(:class="{'active': routeIsDocumentsCompany}", v-if="userIsCompany")
          router-link(:to="{name: 'professional.company.documents.index'}")
            | Documentos
</template>



// WEBPACK FOOTER //
// src/layout/headers/topMenuProfessional.vue